<template>
  <embed-viewer-route-view :url="url" :title="title" :can-go-back="canGoBack"></embed-viewer-route-view>
</template>
<script>
import UserApi from '@/user-api';

export default {
  name: 'home',
  data() {
    return {
      url: '',
      title: '',
      canGoBack: false
    };
  },
  beforeRouteEnter(to, from, next) {
    UserApi.getWorkById(to.params.id).then(work => {
      next(vm => {
        vm.canGoBack = !!from.name;
        vm.title = work.title;
        vm.url = work.embedCode.match('src="(.*?)"')[1];
      });
    });
  }
};
</script>